import Button from '@atlaskit/button';
import { css, jsx } from '@emotion/react';
import CrossIcon from '@atlaskit/icon/glyph/cross';
import React from 'react';
import TextField from '@atlaskit/textfield';

type SearchBarProps = {
  placeholder?: string;
  onChange: (value: string) => void;
  onReset: () => void;
  value: string;
}

const defaultProps = {
  placeholder: ''
};

const SearchBar = (props: SearchBarProps) => {
  const { placeholder, onReset, onChange, value } = props;

  return(
  <TextField
    placeholder={placeholder}
    isCompact
    aria-label={placeholder}
    value={value}
    onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange(e.target.value)}
    elemAfterInput={value.length > 0 ? <Button
      onClick={() => onReset()}
      css={css`margin-right: 6px;`}
      appearance="subtle" spacing="none"
      aria-label="Clear filter"
      iconAfter={<CrossIcon
        size="small" label=""/>}
    /> : null}
  />
  )
}

SearchBar.defaultProps = defaultProps;

export default SearchBar;

